import { MainContentLayout } from 'shared/ui/layout';

import { AddTariff } from 'features/tariff/add';

export function AddTariffPage() {
  return <MainContentLayout element={<AddTariff />} />;
}
